export const sumAverageStatement = (calculatorUtilities) => {
  const utilityTitles = ["Water", "Hot water", "Trash", "Sewer"];

  let finalArray = [];

  let zeroOccupants = [];
  let oneOccupants = [];
  let twoOccupants = [];
  let threeOccupants = [];
  let fourOccupants = [];
  let fiveOccupants = [];

  utilityTitles.forEach((name) => {
    const tenantArray = calculatorUtilities[name].utilityPerTenant;

    zeroOccupants.push(tenantArray[0]);
    // for (let i = 0; i < utilityTitles.length; i++) {
    oneOccupants.push(tenantArray[1]);
    twoOccupants.push(tenantArray[2]);
    threeOccupants.push(tenantArray[3]);
    fourOccupants.push(tenantArray[4]);
    fiveOccupants.push(tenantArray[5]);

    // }

    // console.log(name);
  });

  // console.log(0, zeroOccupants);
  // console.log(1, oneOccupants);
  // console.log(2, twoOccupants);
  // console.log(3, threeOccupants);
  // console.log(4, fourOccupants);
  // console.log(5, fiveOccupants);

  //for 0 occupant
  const addZero = (zeroOccupants) => zeroOccupants.reduce((a, b) => a + b, 0);

  let sumZero = addZero(zeroOccupants);
  // console.log(sumZero);

  //for 1 occupant
  const addOne = (oneOccupants) => oneOccupants.reduce((a, b) => a + b, 0);

  let sumOne = addOne(oneOccupants);
  // console.log(sumOne);

  //for 2 occupant
  const addTwo = (twoOccupants) => twoOccupants.reduce((a, b) => a + b, 0);

  let sumTwo = addTwo(twoOccupants);
  // console.log(sumTwo);

  //for 3 occupant
  const addThree = (threeOccupants) =>
    threeOccupants.reduce((a, b) => a + b, 0);

  let sumThree = addThree(threeOccupants);
  // console.log(sumThree);

  //for 4 occupant
  const addFour = (fourOccupants) => fourOccupants.reduce((a, b) => a + b, 0);

  let sumFour = addFour(fourOccupants);
  // console.log(sumFour);

  //for 5 occupant
  const addFive = (fiveOccupants) => fiveOccupants.reduce((a, b) => a + b, 0);

  let sumFive = addFive(fiveOccupants);
  // console.log(sumFive);

  finalArray.push(sumZero);
  finalArray.push(sumOne);
  finalArray.push(sumTwo);
  finalArray.push(sumThree);
  finalArray.push(sumFour);
  finalArray.push(sumFive);

  // console.log(finalArray);
  return finalArray;

  // for (let index = 0; index < utilityTitles.length; index++) {
  //   const name = utilityTitles[index];

  //   tenantArray = calculatorUtilities[name].utilityPerTenant[1];
  //   let occupantArray = [];
  //   occupantArray.push(tenantArray);

  //   console.log(tenantArray, name, index, occupantArray);
  // }

  // const add = (tenantArray) => tenantArray.reduce((a, b) => a + b, 0);

  // let sum = add(tenantArray);

  // let newBTVBill = 0;
  // let newATPBill = 0;
  // let newOwnerBill = 0;

  // for (let val in calculatorUtilities) {
  //   newBTVBill += calculatorUtilities[val].BTV;
  //   newATPBill += calculatorUtilities[val].ATP;
  // }
  // newOwnerBill = (newBTVBill - newATPBill).toFixed(2);

  // return sum;
};
